import * as React from "react";
import Slider, { Settings as SliderSettings } from "react-slick";

import * as constants from "../constants";
import TestimonialDetails, {
  TestimonialDetailsProps,
} from "./TestimonialDetails";
import TestimonialImage from "./TestimonialImage";
import Testimonials from "./Testimonials";
import PartnerImage from "./PartnerImage";

export interface TestimonialContainerProps {
  testimonialData?: TestimonialDetailsProps[];
  partnerImages?: string[];
}

class TestimonialContainer extends React.Component<TestimonialContainerProps> {
  private bubbleSlider: Slider;

  public static defaultProps: Partial<TestimonialContainerProps> = {
    testimonialData: constants.TESTIMONIAL_DATA,
    partnerImages: constants.PARTNER_IMGS,
  };

  private settings: SliderSettings = {
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    focusOnSelect: true,
    infinite: true,
    arrows: false,
    dots: false,
    centerMode: true,
    initialSlide: 0,
    afterChange: index => {
      // update bubble carousel accordingly
      this.bubbleSlider.slickGoTo(index);
    },
  };

  private bubbleSettings: SliderSettings = {
    slidesToShow: 1,
    dots: false,
    arrows: false,
    infinite: true,
    swipe: false,
    fade: true,
    initialSlide: 0,
  };

  private assignRef = (el: Slider) => (this.bubbleSlider = el);

  private renderPartnerImages = () =>
    (this.props.partnerImages as string[]).map((src, i) => (
      <PartnerImage key={i} src={src} />
    ));

  private renderTestimonialImages = () =>
    (this.props
      .testimonialData as TestimonialDetailsProps[]).map((props, i) => (
      <div key={i}>
        <TestimonialImage {...props} />
      </div>
    ));

  private renderTestimonialDetails = () =>
    (this.props
      .testimonialData as TestimonialDetailsProps[]).map((props, i) => (
      <div key={i}>
        <TestimonialDetails {...props} />
      </div>
    ));

  public render() {
    return (
      <Testimonials
        assignRef={this.assignRef}
        settings={this.settings}
        bubbleSettings={this.bubbleSettings}
        partnerImgs={this.renderPartnerImages()}
        testimonialImgs={this.renderTestimonialImages()}
      >
        {this.renderTestimonialDetails()}
      </Testimonials>
    );
  }
}

export default TestimonialContainer;



// WEBPACK FOOTER //
// ./src/routes/TestimonialsCarousel/components/TestimonialsContainer.tsx